import { ObjectRepository } from '@framework/repository';
import { RTDBPath } from 'balus-common';
import { Workspace } from './Workspace';
import type { WorkspaceJSON, WorkspaceId } from 'balus-common';

export type WorkspaceEntityRepository = ObjectRepository<WorkspaceJSON, Workspace>;
export const createWorkspaceEntityRepository = (workspaceId: WorkspaceId): WorkspaceEntityRepository =>
  new ObjectRepository(Workspace, RTDBPath.Workspace.workspaceEntityPath(workspaceId));
